'use strict';
Object.defineProperty(exports, '__esModule', { value: true });
var prefix = 'fasds';
var iconName = 'thumbs-up';
var width = 512;
var height = 512;
var aliases = [128077,61575];
var unicode = 'f164';
var svgPathData = ['M160 200.9l0 23.1 0 96 0 64 0 25.7 21.4 14.2 72 48 12.1 8.1 14.5 0 120 0 48 0 0-56 24 0 0-72 24 0 0-80 16 0 0-96-48 0-153.8 0C327 142.8 336 105.8 336 67.7L336 32l-96 0 0 35.7c0 43.7-19.9 85.1-54 112.4l-7.9 6.4-18 14.4z', 'M0 192H128V480H0V192z'];

exports.definition = {
  prefix: prefix,
  iconName: iconName,
  icon: [
    width,
    height,
    aliases,
    unicode,
    svgPathData
  ]};

exports.faThumbsUp = exports.definition;
exports.prefix = prefix;
exports.iconName = iconName;
exports.width = width;
exports.height = height;
exports.ligatures = aliases;
exports.unicode = unicode;
exports.svgPathData = svgPathData;
exports.aliases = aliases;